import React from 'react';
import i18n from '@nextroll/ar-i18n';
import { Link } from '@nextroll/ar-container-app';

export const PageNotFound = () => {
    const currentUrl = window.location.href;
    const dashUrl = '/dashboard';
    const contactUrl = 'https://www.adroll.com/about/contact';

    return (
        <div className='page-not-found text-center'>
            <i className='page-not-found-icon ar-icon ar-icon-frown' />
            <h3 className='page-not-found-title'>
                { i18n.gettext('Oops, page not found') }
                <br />
            </h3>
            <h5 className='page-not-found-subtitle'>
                {
                    i18n.gettext(
                        'Think this page should work? <Link>Contact us</Link>.',
                        {
                            Link: <Link to={ contactUrl } />,
                        }
                    )
                }
            </h5>
            <div className='page-not-found-buttons'>
                <button
                    className='btn btn-default buyflow-form-button page-not-found-reload-button'
                    type='button'
                >
                    <Link to={ currentUrl }>{ i18n.gettext('Try Again') }</Link>
                </button>
                <button
                    className='btn btn-default buyflow-form-button page-not-found-go-to-dash'
                    type='button'
                >
                    <Link to={ dashUrl }>{ i18n.gettext('Go To Dashboard') }</Link>
                </button>
            </div>
        </div>
    );
};
